module.exports = __webpack_public_path__ + "img/page-5-line-water.41d0b662.png";